import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { NO_OF_HEADER_LINKS } from 'config/constants';
import { useTopMenuArticles } from 'connectors/articleInterface/article/Article';
import { useSettings } from 'connectors/Settings/Settings';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import useTranslation from 'next-translate/useTranslation';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

const HeaderLinks: FC = () => {
    const { t } = useTranslation();
    const headerLinks = useTopMenuArticles(NO_OF_HEADER_LINKS);
    const domainConfig = useDomainConfig();
    const [storesUrl] = getInternationalizedStaticUrls(['/stores'], domainConfig.url);
    const settings = useSettings();

    const linkTwClass = 'ml-7 no-underline text-white font-bold hover:text-white hover:underline';

    return (
        <div className="notVl:hidden">
            {settings && settings.storeCount > 0 && (
                <ExtendedNextLink aria-label={t('List of stores')} className={linkTwClass} href={storesUrl}>
                    {t('Stores')}
                </ExtendedNextLink>
            )}
            {headerLinks.map((link) => (
                <ExtendedNextLink
                    key={link.name}
                    className={linkTwClass}
                    href={link.link ?? link.slug}
                    target={link.external ? '_blank' : '_self'}
                >
                    {link.name}
                </ExtendedNextLink>
            ))}
        </div>
    );
};

export default HeaderLinks;
